import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditWebshop extends Component {

    state = {
        webshop: this.props.webshop,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { webshop = 0 } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditWebshop"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Webshop">
            <Form>
                <div>
                    { ['No webshop', 'Webshop and store', 'Only webshop'].map((text, value) => (
                        <label key={value} className="radio">
                            <input
                                type="radio"
                                name="webshop"
                                value={value}
                                checked={webshop === value}
                                onChange={e => this.setState({ webshop: value })} />
                                {text}
                        </label>
                    ))}
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditWebshop



// WEBPACK FOOTER //
// ./src/components/LBUs/EditWebshop.js